import { useMutation, useQueryClient } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { toastErrorApi, toastExito } from "@/lib/toast";
import {
  crearEquivalencia,
  editarEquivalencia,
  eliminarEquivalencia,
  type CrearEquivalenciaInput,
  type EditarEquivalenciaInput,
} from "../services/equivalencias-service";

export function useCrearEquivalencia(opts?: { onCreado?: () => void }) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CrearEquivalenciaInput) => crearEquivalencia(input),
    onSuccess: (equiv) => {
      toastExito({ title: `Equivalencia ${equiv.claveUnidadSat} ↔ ${equiv.unidadSap} creada`, message: "Disponible para la conciliación de órdenes de compra." });
      void qc.invalidateQueries({ queryKey: qk.adminEquivalenciasUnidad });
      opts?.onCreado?.();
    },
    onError: toastErrorApi,
  });
}

export function useEditarEquivalencia(opts?: { onEditado?: () => void }) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: EditarEquivalenciaInput }) => editarEquivalencia(id, input),
    onSuccess: () => {
      toastExito({ title: "Equivalencia actualizada", message: "Cambios guardados." });
      void qc.invalidateQueries({ queryKey: qk.adminEquivalenciasUnidad });
      opts?.onEditado?.();
    },
    onError: toastErrorApi,
  });
}

export function useEliminarEquivalencia() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => eliminarEquivalencia(id),
    onSuccess: () => {
      toastExito({ title: "Equivalencia dada de baja", message: "Quedó inactiva · puedes reactivarla editándola." });
      void qc.invalidateQueries({ queryKey: qk.adminEquivalenciasUnidad });
    },
    onError: toastErrorApi,
  });
}
